export const light = {
  'user/loginBoxShadow': 'rgba(0, 0, 0, 0.1)',
  'user/loginInfoColor': '#969696',
  'user/bioBg': '#eeeeef'
}
export const dark = {
  'user/loginBoxShadow': 'rgba(255, 255, 255, 0.1)',
  'user/loginInfoColor': '#fff',
  'user/bioBg': '#222'
}
